// swReady.js  – load this once at start-up
export const swReady = (async () => {
    if (!('serviceWorker' in navigator)) {
      throw new Error('Service-workers not supported');
    }
  
    // Register **only once**; subsequent calls merely return the same promise
    await navigator.serviceWorker.register('/sw-push.js', {
      scope: '/',
      updateViaCache: 'none',
    }).then((reg) => console.log("registration created at swready" , reg));
  
    // Wait until the worker is activated
    const registration = await navigator.serviceWorker.ready;
  
    // Make sure it controls the page; if not, hard-refresh once
    if (!navigator.serviceWorker.controller) {
      sessionStorage.setItem('sw_reload_once', 'yes');
      
      // location.reload();                // will be controlled after reload
      return new Promise(() => {});     // never resolves on first pass
    } else {
      sessionStorage.removeItem('sw_reload_once');
    }
  
    return registration;                // <-- use this everywhere else
  })();
  